
const accordionSummary:any={
    styleOverrides: {
        root:{

            content: {
                margin: "16px 0",
            }
        }
    }
}

export default accordionSummary;
